import { Navigate, useRoutes } from "react-router-dom"
import { CheckItemsPage } from "../CheckItemsPage"
import { GarbageCheckPage } from "../GarbageCheckPage"
import { ErrandPage } from "../ErrandPage"
import { EvidencePage } from "../EvidencePage"
import { FinishPage } from "../FinishPage"
import { ReadyForErrandsPage } from "../ReadyForErrandsPage"
import { TasksPage } from "../TasksPage"
import { TroubleReportPage } from "../TroubleReportPage"
import { TroublesConfirmPage } from "../TroublesConfirmPage"
import { RoomSupplyPage } from "../RoomSupplyPage"
import { LostItemPage } from "../LostItemPage"
import { useTranslation } from "@/hooks/useTranslation"

export const CleaningReportRoutes = () => {
    const { t } = useTranslation()

    const routes = [
        {
            path: `tasks/*`,
            element: <TasksPage />
        },
        {
            path: `evidences`,
            element: <EvidencePage />
        },

        {
            path: `ready-for-errands`,
            element: <ReadyForErrandsPage />
        },
        {
            path: `errands/*`,
            element: <ErrandPage />
        },
        {
            path: `checkitems`,
            element: <CheckItemsPage />
        },
        {
            path: `room-supply`,
            element: <RoomSupplyPage />
        },
        {
            path: `lost-items`,
            element: <LostItemPage />
        },
        {
            path: `garbage-check`,
            element: <GarbageCheckPage />
        },
        {
            path: `ready-for-troubles`,
            element: (
                <TroublesConfirmPage title={t("トラブルはありましたか？")} />
            )
        },
        {
            path: `troubles`,
            element: <TroubleReportPage />
        },
        {
            path: `troubles/next`,
            element: <TroublesConfirmPage title={t("さらに報告しますか？")} />
        },
        {
            path: `finish`,
            element: <FinishPage />
        },
        {
            path: "/*",
            element: <Navigate to={`tasks/list`} />
        }
    ]

    const element = useRoutes(routes)

    return element
}
